module.exports = __webpack_public_path__ + "img/mindfullness.b8cd6575.jpg";